import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/admin/courses/$courseId/view-avatars")();
